import React, { useState } from "react";
import Fancybox from "../../../../elements/Fancybox";

const LeftImages = ({ images = [], content, maxLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => setIsExpanded(!isExpanded);

  if (!content) return null;

  const shouldTruncate = content.length > maxLength;
  const displayedText =
    isExpanded || !shouldTruncate
      ? content
      : content.slice(0, maxLength) + "...";

  return (
    <div className="max-w-56 p-2 bg-white rounded-md flex flex-col space-y-1 float-left chat-text-box__content">
      <Fancybox
        options={{
          Carousel: {
            infinite: false,
          },
        }}
      >
        <div className="flex flex-wrap gap-2 justify-end text-slate-700 chat-text-box__content__text--image">
          {images?.slice(0, 6)?.map((image, i) => (
            <a
              data-fancybox="gallery-left-chat"
              href={image?.src}
              data-preload="true"
              key={i.toString()}
            >
              {i < 5 ? (
                <div
                  className="cursor-pointer w-16 h-16 image-fit"
                  role="presentation"
                >
                  <img
                    alt={image?.alt}
                    className="rounded-md w-full h-full object-center object-cover hover:scale-[1.1] transition-all duration-500"
                    src={image?.src}
                  />
                </div>
              ) : (
                <div className="cursor-pointer w-16 h-16 image-fit flex items-center justify-center gap-1 rounded-md relative">
                  <img
                    alt={image?.alt}
                    className="rounded-md w-full h-full object-center object-cover hover:scale-[1.1] transition-all duration-500"
                    src={image?.src}
                  />
                  {images.length > 6 && (
                    <div className="absolute z-[1] text-white font-medium top-0 left-0 w-full h-full rounded-md flex items-center justify-center bg-black/40">
                      +{images.length - 5}
                    </div>
                  )}
                </div>
              )}
            </a>
          ))}
          {/* Include all remaining images for Fancybox (hidden) */}
          {images?.slice(6)?.map((image, i) => (
            <a
              data-fancybox="gallery-left-chat" // Group all images in same Fancybox gallery
              href={image?.src}
              key={`hidden-${i}`}
              style={{ display: "none" }}
            >
              <div
                className="cursor-pointer w-16 h-16 image-fit"
                role="presentation"
              >
                <img
                  alt={image?.alt}
                  className="rounded-md w-full h-full object-center object-cover hover:scale-[1.1] transition-all duration-500"
                  src={image?.src}
                />
              </div>
            </a>
          ))}
        </div>
      </Fancybox>
      <div className="text-sm font-medium">
        {displayedText}
        {shouldTruncate && (
          <span
            onClick={toggleReadMore}
            className="ml-1 text-blue-400 cursor-pointer hover:underline"
          >
            {isExpanded ? "Read Less" : "Read More"}
          </span>
        )}
      </div>
    </div>
  );
};

export default LeftImages;
